exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#toast-box[data-v-373fc2a0] {\n  position: fixed;\n  top: 0.75rem;\n  right: 0.75rem;\n  z-index: 1010;\n  width: 300px;\n  max-height: 100vh;\n  overflow: auto;\n  transition: ease-in-out;\n  height: auto;\n}", ""]);

// exports
